import { render, staticRenderFns } from "./FirstShopModal.vue?vue&type=template&id=a84ef902"
import script from "./FirstShopModal.vue?vue&type=script&lang=js"
export * from "./FirstShopModal.vue?vue&type=script&lang=js"
import style0 from "./FirstShopModal.vue?vue&type=style&index=0&id=a84ef902&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports